<template>
    <h2>Footer</h2>
</template>